import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=5c03fc25&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ringg_deliveryhub-app_production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c03fc25"]])

export default __exports__